// SPDX-FileCopyrightText: 2026 Nogweii <code@nogweii.net>
//
// SPDX-License-Identifier: 0BSD

import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
